import AlYusrAxiosApiInstance from "../axios/alYusrAxiosApiInstance";
import { AlYuserApiUrls } from "../configuration";
import { GroupPrinterResult, GroupPrintersModel, PrintersModel, PrintersTransactionsModel, PrintersTransactionsResult } from "../models/printers/printersModel";
import { handleError } from "../utils";

export const getAllPrinters = async (): Promise<PrintersModel> => {
    try {
        let response: PrintersModel = await AlYusrAxiosApiInstance.get(
            AlYuserApiUrls.printerSetting.getAllPrinters
        );
        // @ts-ignore
        return response ? response : [];
    } catch (err) {
        alert(handleError(err));
    }
    // @ts-ignore
    return [];
};

export const getTransactionPrintingSettingsByUserId = async (userId:string): Promise<PrintersTransactionsModel> => {
    try {
        let response: PrintersTransactionsModel = await AlYusrAxiosApiInstance.get(
            `${AlYuserApiUrls.printerSetting.getTransactionPrintingSettingsByUserId}?userId=${userId}`
        );
        // @ts-ignore
        return response ? response : [];
    } catch (err) {
        alert(handleError(err));
    }
    // @ts-ignore
    return [];
};

export const saveTransactionPrintingSettings = async (request:{TransactionPrintingSettings:PrintersTransactionsResult[]}):
 Promise<PrintersTransactionsModel> => {
    try {
        let response: PrintersTransactionsModel = await AlYusrAxiosApiInstance.post(
            AlYuserApiUrls.printerSetting.saveTransactionPrintingSettings,
            request
        )
        // @ts-ignore
        return response ? response : [];
    } catch (err) {
        alert(handleError(err));
    }
    // @ts-ignore
    return [];
};

export const getGroupPrinters = async (): Promise<GroupPrintersModel> => {
    try {
        let response: GroupPrintersModel = await AlYusrAxiosApiInstance.get(
            AlYuserApiUrls.printerSetting.getGroupPrinters
        );
        // @ts-ignore
        return response ? response : [];
    } catch (err) {
        alert(handleError(err));
    }
    // @ts-ignore
    return [];
};
export const updateGroupPrinters = async ({request}:{request:GroupPrinterResult[]}): Promise<GroupPrintersModel> => {
    try {
        let response: GroupPrintersModel = await AlYusrAxiosApiInstance.post(
            AlYuserApiUrls.printerSetting.updateGroupPrinters,
            request
        );
        // @ts-ignore
        return response ? response : [];
    } catch (err) {
        alert(handleError(err));
    }
    // @ts-ignore
    return [];
};